import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { colors } from "../../constants/colors";

export const MainContainer = styled("div")(({ theme }) => ({
  padding: "24px 48px",
  height: "100vh",
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    padding: "16px 20px",
  },
}));

export const TableContainer = styled(Box)(({ theme }) => ({
  marginTop: 24,
}));

/** ป้ายสถานะในตาราง — พื้นโทนอ่อน ตัวอักษรสีเดียวกับจุดใน dropdown */
export const StatusChip = styled("span", {
  // กัน prop ของ style รั่วลง DOM ไม่งั้น React เตือน unknown attribute
  shouldForwardProp: (prop) => prop !== "chipColor" && prop !== "chipBg",
})<{ chipColor?: string; chipBg?: string }>(({ chipColor, chipBg }) => ({
  display: "inline-block",
  minWidth: 96,
  padding: "4px 16px",
  borderRadius: 16,
  fontSize: 16,
  textAlign: "center",
  whiteSpace: "nowrap",
  color: chipColor || colors.gray,
  backgroundColor: chipBg || colors.extraLightGray,
}));

/**
 * เลขที่คำร้องในตาราง กดแล้วเปิด modal รายละเอียด
 * ใช้ themeMainColor ไม่ใช่ themeSecondColor เพราะ themeSecondColor เป็นน้ำเงินตายตัว
 * ซึ่งจะขัดกับธีมเขียวของฝั่งผู้เช่า (colors.tsx สลับ themeMainColor ตาม roleId ให้แล้ว)
 */
export const LinkText = styled("span")(({ theme }) => ({
  color: colors.themeMainColor,
  cursor: "pointer",
  "&:hover": { textDecoration: "underline" },
}));

/** หัวข้อย่อยในโมดัล เช่น "สัญญาเช่าที่มีเงินมัดจำ" */
export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  color: colors.themeMainColor,
}));

/** แถวข้อมูลแบบ label/value ใน modal รายละเอียด */
export const DetailRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "220px 1fr",
  gap: 16,
  padding: "12px 24px",
  borderBottom: `1px solid ${colors.lightGray}`,
  "&:last-of-type": { borderBottom: "none" },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
    gap: 4,
  },
}));

/** กล่องไฟล์แนบที่เลือกไว้ก่อนส่ง */
export const FileBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${colors.lightGray}`,
  borderRadius: 8,
  padding: "8px 12px",
}));

/**
 * แถวในตาราง "รายละเอียดการคำนวณเงินคืน" — รายการ / ยอดตั้งต้น / หัก / คงเหลือ
 * ใช้ grid ไม่ใช่ TableCustom เพราะมีแค่ 2-3 แถวคงที่ ไม่ต้องมี pagination/sort
 * ตัวเลข 3 คอลัมน์ท้ายชิดขวาเพื่อให้อ่านเทียบกันได้
 */
export const DeductRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 120px 120px 140px",
  gap: 8,
  padding: "10px 16px",
  fontSize: 16,
  alignItems: "center",
  "& > span:not(:first-of-type)": { textAlign: "right" },
  "& + &": { borderTop: `1px solid ${colors.lightGray}` },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr 90px 90px 100px",
    fontSize: 14,
    padding: "8px 12px",
  },
}));

/**
 * แถวในตารางคำนวณเงินคืนของ "โมดัลพิจารณา" — คอลัมน์เดียวกับ DeductRow
 * แต่แถวมี input จึงจัดกลางแนวตั้งและลด padding ลง
 */
export const DeductFormRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 120px 120px 140px",
  gap: 8,
  padding: "8px 16px",
  fontSize: 16,
  alignItems: "start",
  "& > span": { paddingTop: 10 },
  "& > span:not(:first-of-type)": { textAlign: "right" },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr 90px 90px 100px",
    fontSize: 14,
    padding: "8px 12px",
  },
}));
